/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Order_Internal_Code_SuccessInputs */

const vi_toast_order_internal_code_success = /** @type {(inputs: Toast_Order_Internal_Code_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã cập nhật mã đơn nội bộ`)
};

/**

* @param {Toast_Order_Internal_Code_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_order_internal_code_success = /** @type {((inputs?: Toast_Order_Internal_Code_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Order_Internal_Code_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_order_internal_code_success(inputs)
});